import { Caption1 } from "../../styles/typography";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";

const StyledToastContainer = styled(ToastContainer)`
  z-index: 99999999;

  position: fixed;
  right: 0;
  bottom: 0;

  @media screen and (min-width: 600px) {
    width: 400px !important; // as per kelly's suggestion
  }
  &&&.Toastify__toast-container {
    box-sizing: border-box;
    margin: 24px;
    right: 0;
    bottom: 0;
    @media screen and (max-width: 600px) {
      width: auto;
      left: 0;
    }
  }

  .Toastify__toast {
    margin: 0;
    background: rgb(${(props) => props.theme.colors.white});
    /* padding: 0; */
    margin-bottom: 8px;
    border-radius: 8px;
    border: 2px solid rgb(${(props) => props.theme.colors.neutral100});
    box-shadow: ${(props) => props.theme.shadows.shadow600()};
    /* height: unset; */
    /* min-height: unset;
    min-width: unset;
    max-width: unset;
    width: unset; */
  }
  .Toastify__toast-body {
    margin: 0;
    padding: 8px 12px 13px 12px;
    min-width: unset;
    max-width: unset;
    width: unset;

    ${Caption1} {
      padding-top: 4px;
      color: rgb(${(props) => props.theme.colors.neutral400});
    }

    height: unset;
    min-height: unset;
  }
  .Toastify__progress-bar {
    background: linear-gradient(
      90deg,
      #dbf1da 0%,
      #d0ebfb 30.21%,
      #dccffc 68.75%,
      #f4d7e5 100%
    );
    height: 4px;
    border-top: 2px solid rgb(${(props) => props.theme.colors.neutral100});
  }

  .Toastify__progress-bar--error {
    background: rgb(${(props) => props.theme.colors.error200});
  }

  .Toastify__progress-bar--success {
    background: rgb(${(props) => props.theme.colors.success200});
  }

  .Toastify__toast-icon {
    padding-top: 4px;
  }
`;

export default StyledToastContainer;
